import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Box, Stack, Typography } from '@mui/material';


export default function SpeciesSearch({ species, setSpecies, onSelect, canAdd=true }) {
    const [value, setValue] = React.useState(null);
    const [open, setOpen] = React.useState(false);
    const [newSpecies, setNewSpecies] = React.useState({
        commonName: '',
        scientificName: '',
    });

    const handleDialogOpen = () => {
        setOpen(true);
    };

    const handleDialogClose = () => {
        setOpen(false);
    };

    const handleDialogSave = () => {
        // setSpecies((prevSpecies) => [...prevSpecies, newSpecies]);
        setValue(newSpecies);
        onSelect(newSpecies, true);
        setOpen(false);
        // reset newSpecies
        setNewSpecies({
            commonName: '',
            scientificName: '',
        });
    };

    return (
        <>
            <Autocomplete
                value={value}
                onChange={(event, newValue) => {
                    if (typeof newValue === 'string') {
                        
                        setValue({
                            commonName: newValue.commonName,
                            scientificName: newValue.scientificName,
                        });
                        
                        onSelect(newValue);
                    } else if (newValue && newValue.inputValue) {
                        handleDialogOpen();
                    } else {
                        setValue(newValue);
                        onSelect(newValue);
                    }
                }}
                filterOptions={(options, params) => {

                    const filtered = options.filter((name)=>{
                        // matches common name or scientific name
                        const commonName = name.commonName.toLowerCase();
                        const scientificName = name.scientificName.toLowerCase();
                        const input = params.inputValue.toLowerCase();
                        return commonName.includes(input) || scientificName.includes(input);
                    });

                
                    const { inputValue } = params;
                    const isExisting = options.some(
                        (option) =>
                            inputValue === option.commonName ||
                            inputValue === option.scientificName
                    );
                    if (inputValue !== '' && !isExisting && canAdd) {
                        filtered.push({
                            inputValue,
                            commonName: `Add "${inputValue}"`,
                        });
                    }
                
                    return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={species}
                getOptionLabel={(option) => {
                    
                    if (typeof option === 'string') {
                        return option;
                    }
                    if (option.inputValue) {
                        return option.inputValue;
                    }
                    return option.commonName;
                }}
                renderOption={(props, option) =>{
                    props.key = option.scientificName;
                    //common name with scientific name underneath
                    return (
                    <Stack {...props}>
                        <Typography  variant='body1'>{option.commonName}</Typography>
                        <Typography variant="subtitle2">{option.scientificName}</Typography>
                    </Stack>
                    )
                }
            }
                sx={{ width: 300 }}
                freeSolo
                renderInput={(params) => <TextField {...params} label="Enter species name..." />}
            />

            <Dialog open={open} onClose={handleDialogClose}>
                <DialogTitle>Add New Species</DialogTitle>
                <DialogContent>
                    <TextField
                        label="Common Name"
                        value={newSpecies.commonName}
                        onChange={(event) =>
                            setNewSpecies((prevSpecies) => ({
                                ...prevSpecies,
                                commonName: event.target.value,
                            }))
                        }
                    />
                    <TextField
                        label="Scientific Name"
                        value={newSpecies.scientificName}
                        onChange={(event) =>
                            setNewSpecies((prevSpecies) => ({
                                ...prevSpecies,
                                scientificName: event.target.value,
                            }))
                        }
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Cancel</Button>
                    <Button onClick={handleDialogSave}
                        color='primary'
                        variant='contained'
                        disabled={!newSpecies.commonName || !newSpecies.scientificName}

                    >Save</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
